
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import { intermediateTierSchema } from "@/contexts/program-creation/types";
import TrainingHistorySection from "./TrainingHistorySection";
import CurrentRoutineSection from "./CurrentRoutineSection";
import ProgressChallengesSection from "./ProgressChallengesSection";

interface IntermediateTierFormContentProps {
  form: UseFormReturn<z.infer<typeof intermediateTierSchema>>;
}

export default function IntermediateTierFormContent({ form }: IntermediateTierFormContentProps) {
  return (
    <>
      <TrainingHistorySection form={form} />
      <CurrentRoutineSection form={form} />
      <ProgressChallengesSection form={form} />
    </>
  );
}
